import type {
  BeforeRemoveNavigationEvent,
  NavigationActionPayloadWithMaintenanceFlag,
} from './types';

/**
 * Prevents screen dismissal if it wasn't caused because of the corresponding flag.
 */
export const preventScreenDismissalIfNecessary = (
  event: BeforeRemoveNavigationEvent,
) => {
  const { payload } = event.data.action;
  const actionPayload = payload as NavigationActionPayloadWithMaintenanceFlag;

  const shouldDisableMaintenanceMode = Boolean(
    actionPayload?.shouldDisableMaintenanceMode,
  );

  // close the screen if it was intended...
  if (shouldDisableMaintenanceMode) return;

  // ...otherwise, prevent the screen from closing
  event.preventDefault();
};
